import React from "react";
import FeatureCard from "./FeatureCard";

import './FeatureSection.css';

const FeaturesSection = () => {
  const features = [
    {
      icon: "✅",
      title: "Diversified in One Move",
      description:
        "Your ETH is spread across high-performing assets like BTC, ETH, XRP, ADA, and SOL.",
    },
    {
      icon: "🔄",
      title: "Monthly Rebalancing",
      description:
        "Stay in sync with market trends — no need to lift a finger.",
    },
    {
      icon: "⛓️",
      title: "Fully On-Chain & Transparent",
      description:
        "No middlemen. No hidden fees. Just Ethereum smart contracts.",
    },
    {
      icon: "🚪",
      title: "Redeem Anytime",
      description:
        "Exit your position on your terms, directly from your wallet.",
    },
    {
      icon: "📈",
      title: "Built for Long-Term Growth",
      description:
        "Inspired by the best of traditional index investing — optimized for Web3.",
    },
  ];

  return (
    <section className="feature-section px-5 py-32 bg-slate-50">
      <div className="mx-auto my-0 max-w-[1200px]">
        <h2 className="mb-20 text-5xl font-bold text-center">
          Smarter&nbsp;Exposure. Zero&nbsp;Complexity.
        </h2>
        <div className="grid gap-8 grid-cols-[repeat(auto-fit,minmax(280px,1fr))]">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
